import {
  useDownloadInvoiceReportSampleCsv,
  GetInvoiceReportSampleImportCsvParams,
} from '@/context/services/invoice_reports/InvoiceReportSampleCsv.service';
import { useDownload } from '@/hooks/useDownload';
import { useTranslation } from '@/i18n';
import { toHtmlNode } from '@/utils/toHtmlNode';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback } from 'react';

export const useDownloadSampleCsv = () => {
  const { t } = useTranslation();
  const notify = useToastAPI();
  const download = useDownload();
  const fetchSampleCsv = useDownloadInvoiceReportSampleCsv();

  return useCallback(
    async (params: GetInvoiceReportSampleImportCsvParams) => {
      const genericErrorTitle = t(
        'invoice_reports.list_import_drawer.import_error_common_toast'
      );
      try {
        const { blob, fileName } = await fetchSampleCsv(params);
        download({ value: blob, fileName });
      } catch (error) {
        const apiMsg =
          error instanceof Error && error.message ? error.message : undefined;
        notify.error({
          title: apiMsg ? toHtmlNode(apiMsg) : genericErrorTitle,
          duration: 5,
        });
      }
    },
    [download, fetchSampleCsv, notify, t]
  );
};
